import { render, staticRenderFns } from "./Inventory.vue?vue&type=template&id=88222818&scoped=true&"
import script from "./Inventory.vue?vue&type=script&lang=js&"
export * from "./Inventory.vue?vue&type=script&lang=js&"
import style0 from "./Inventory.vue?vue&type=style&index=0&id=88222818&prod&lang=css&"
import style1 from "./Inventory.vue?vue&type=style&index=1&id=88222818&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88222818",
  null
  
)

export default component.exports